export const HELPERS_TOP = "0.25rem";
export const HELPERS_LEFT = "0.5rem";
export const CONTROLS_CONTAINER_VERTICAL_TOP = "1.325em";
export const VERTICAL_TOP_OFFSET = "0.5rem";
